/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `secure_parking` - Parcare păzită / garaj
 * * `street_parking` - Parcare stradală / neprotejată
 */
export enum ParkingModeEnum {
  SECURE_PARKING = 'secure_parking',
  STREET_PARKING = 'street_parking',
}
